<template>
  <div>

    <section class="content">

      <div v-if="user.type === 'admin'">
        <!-- <button class="btn btn-primary" @click="updateDbLedger()">Update Db Ledger</button> -->
        <!-- <button class="btn btn-primary" @click="updateDatabase()">Update Db</button>  -->
        <!-- <button class="btn btn-primary" @click="downloadDatabase()"><i class="fa fa-download"></i>Download Db</button> -->
        <a :href="this.$axios.defaults.baseURL + `/user/database?mobile=${user.mobile}`" class="btn btn-primary pull-right"><i class="fa fa-download"></i>Download Backup</a>
      </div>

      <div class="row" v-if="canAccess('Setting-view-any')">
        <div class="col-md-3">
          <!-- About Me Box -->
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">About Me</h3>
            </div>
            <!-- /.box-header -->
            <div class="box-body">
              <div class="text-center">
                <div v-if="user.type !== 'admin'">
                  <img 
                  class="profile-user-img img-circle"
                  :src= this.photo
                  alt="User profile picture"
                />
                </div>
                <div v-else><i class="fa fa-user" style="font-size: 25px;"></i></div>
              </div>
              <h3 class="profile-username text-center">{{user.name}}</h3>
              <ul class="list-group list-group-unbordered">
                <li class="list-group-item">
                  <b>Code</b> <a class="pull-right">{{user.code}}</a>
                </li>
                <li class="list-group-item">
                  <b>Mobile</b> <a class="pull-right">{{user.mobile}}</a>
                </li>  
                <li class="list-group-item">
                  <b>Email</b> <a class="pull-right">{{user.email}}</a>
                </li>

                <div v-if="user.type !== 'admin'">
                  <li class="list-group-item">
                    <b>Gender</b> <a class="pull-right">{{profile.gender}}</a>
                  </li>
                  <li class="list-group-item">
                    <b>DOB</b> <a class="pull-right">{{profile.dob | myDate}}</a>
                  </li>
                  <li class="list-group-item">
                    <b>Father Name</b> <a class="pull-right">{{profile.fatherName}}</a>
                  </li>
                </div>
              </ul>

              <div v-if="user.type !== 'admin'">
                <strong><i class="fa fa-map-marker margin-r-5"></i> Location</strong>
                <p class="text-muted">{{profile.address}} {{profile.area}} {{profile.district}}</p>
              </div>
              
            </div>
            <!-- /.box-body -->
          </div>
          <!-- /.box -->
        </div>
        <div class="col-md-9" v-if="user.type !== 'admin'">
          <div class="nav-tabs-custom" >
            <ul class="nav nav-tabs">
              <li class="active"><a href="#RelationReference" data-toggle="tab">Relation Reference</a></li>
              <li><a href="#viewlocation" data-toggle="tab">Location</a></li>
              <li><a href="#viewuid" data-toggle="tab">User ID</a></li>
              <li><a href="#viewincome" data-toggle="tab">Income</a></li>
              <li><a href="#viewbusiness" data-toggle="tab">Bank Details</a></li>
              <li><a href="#viewnominee" data-toggle="tab">Nominee</a></li>
              <li><a href="#" @click="newModal" data-toggle="tab">Reset Password</a></li>
            </ul>
            <div class="tab-content">
              <div class="active tab-pane" id="RelationReference">
                  <div class="row" v-if="profile.length > 1">
                        <div class="col-md-6">
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i
                            >Father Name</strong
                            >
                            <p class="text-muted">
                            {{ profile.fatherName }}
                            </p>
                            <hr />
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i
                            >Mother Name</strong
                            >
                            <p class="text-muted">
                            {{ profile.motherName }}
                            </p>
                            <hr />
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i
                            >Spouse Name</strong
                            >
                            <p class="text-muted">
                            {{ profile.spouseName }}
                            </p>
                            <hr />
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i
                            >Guarantor Name</strong
                            >
                            <p class="text-muted">
                            {{ profile.guarantorName }}
                            </p>
                            <hr />
                        </div>
                        <div class="col-md-6">
                            
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i
                            >Guarantor Mobile No.</strong
                            >
                            <p class="text-muted">
                            {{ profile.guarantorPhone }}
                            </p>
                            <hr />
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i>
                            Guarantor Address</strong
                            >
                            <p class="text-muted">
                            {{ profile.guarantorAddress }}
                            </p>
                            <hr />
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i
                            >Guarantor Narration</strong
                            >
                            <p class="text-muted">
                            {{ profile.guarantorNarration }}
                            </p>
                            <hr />
                        </div>
                 </div>
              </div>
              <!-- /.tab-pane -->
              <!-- /.tab-pane -->
                <div class="tab-pane" id="viewlocation">
                    <div class="card card-primary">
                    <div class="card-header">
                        <h3 class="card-title">Location</h3>
                    </div>
                    <!-- /.card-header -->
                    <div class="card-body">
                        <!-- <div class="row">
                        <div class="col-md-6">
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i
                            >Address</strong
                            >
                            <p class="text-muted">
                            {{ profile.address }}
                            </p>
                            <hr />
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i
                            >Area</strong
                            >
                            <p class="text-muted">{{ profile.area }}</p>
                            <hr />
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i
                            >City</strong
                            >
                            <p class="text-muted">{{ profile.city }}</p>
                            <hr />
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i
                            >District</strong
                            >
                            <p class="text-muted">
                            {{ profile.district }}
                            </p>
                            <hr />
                        </div>
                        <div class="col-md-6">
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i
                            >State</strong
                            >
                            <p class="text-muted">
                            {{ profile.state.name }}
                            </p>
                            <hr />
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i>
                            State Code</strong
                            >
                            <p class="text-muted">
                            {{ profile.state.stateCode }}
                            </p>
                            <hr />
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i
                            >Pincode</strong
                            >
                            <p class="text-muted"></p>
                            <hr />
                        </div>
                        </div> -->
                    </div>
                    <!-- /.card-body -->
                    </div>
                    <!-- /.card -->
                </div>
                <!-- /.tab-pane -->
                <div class="tab-pane" id="viewuid">
                    <div class="card card-primary">
                    <div class="card-header">
                        <h3 class="card-title">User Identification</h3>
                    </div>
                    <!-- /.card-header -->
                    <div class="card-body">
                        <!-- <div class="row">
                        <div class="col-md-6">
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i
                            >Pancard Number</strong
                            >
                            <p class="text-muted">{{ profile.panNo }}</p>
                            <hr />
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i
                            >Adhar Card Number</strong
                            >
                            <p class="text-muted">
                            {{ profile.aadharNo }}
                            </p>
                            <hr />
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i
                            >Driving License Number</strong
                            >
                            <p class="text-muted">
                            {{ profile.drivingLicenceNo }}
                            </p>
                            <hr />
                        </div>
                        <div class="col-md-6">
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i
                            >Ration Card Number</strong
                            >
                            <p class="text-muted">
                            {{ profile.rationCardNo }}
                            </p>
                            <hr />
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i>
                            Passport Number</strong
                            >
                            <p class="text-muted">
                            {{ profile.passportNo }}
                            </p>
                            <hr />
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i
                            >Voter ID Card Number</strong
                            >
                            <p class="text-muted">
                            {{ profile.voterIdCardNo }}
                            </p>
                            <hr />
                        </div>
                        </div> -->
                    </div>
                    <!-- /.card-body -->
                    </div>
                    <!-- /.card -->
                </div>
                <!-- /.tab-pane -->

                <div class="tab-pane" id="viewincome">
                    <div class="card card-primary">
                    <div class="card-header">
                        <h3 class="card-title">Income</h3>
                    </div>
                    <!-- /.card-header -->
                    <div class="card-body">
                        <!-- <div class="row">
                        <div class="col-md-6">
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i
                            >Job Type</strong
                            >
                            <p class="text-muted">
                            {{ profile.jobType }}
                            </p>
                            <hr />
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i
                            >Income Amount</strong
                            >
                            <p class="text-muted">
                            {{ profile.incomeAmount }}
                            </p>
                            <hr />
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i
                            >Income Type</strong
                            >
                            <p class="text-muted">
                            {{ profile.incomeType }}
                            </p>
                            <hr />
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i
                            >Income Duration</strong
                            >
                            <p class="text-muted">
                            {{ profile.incomeTime }}
                            </p>
                            <hr />
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i>
                            Min Amount</strong
                            >
                            <p class="text-muted">
                            {{ profile.minAmount }}
                            </p>
                            <hr />
                        </div>
                        <div class="col-md-6">
                            
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i>
                            Max Amount</strong
                            >
                            <p class="text-muted">
                            {{ profile.maxAmount }}
                            </p>
                            <hr />
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i
                            >Business Name</strong
                            >
                            <p class="text-muted">
                            {{ profile.businessName }}
                            </p>
                            <hr />
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i
                            >Business Address</strong
                            >
                            <p class="text-muted">
                            {{ profile.businessAddress }}
                            </p>
                            <hr />
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i
                            >Office Phone</strong
                            >
                            <p class="text-muted">
                            {{ profile.officePhone }}
                            </p>
                            <hr />
                        </div>
                        </div> -->
                    </div>
                    <!-- /.card-body -->
                    </div>
                    <!-- /.card -->
                </div>
                <!-- /.tab-pane -->

                <div class="tab-pane" id="viewbusiness">
                    <div class="card card-primary">
                    <div class="card-header">
                        <h3 class="card-title">
                        Bank Details & Business
                        </h3>
                    </div>
                    <!-- /.card-header -->
                    <div class="card-body">
                        <!-- <div class="row">
                        <div class="col-md-6">
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i
                            >Bank Name</strong
                            >
                            <p class="text-muted" v-if="profile.bank">
                            {{ profile.bank.name }}
                            </p>
                            <hr />
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i
                            >Account Holder Name</strong
                            >
                            <p class="text-muted">
                            {{ profile.accountHolderName }}
                            </p>
                            <hr />
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i
                            >Account Number</strong
                            >
                            <p class="text-muted">
                            {{ profile.accountNumber }}
                            </p>
                            <hr />
                            
                        </div>
                        <div class="col-md-6">
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i
                            >Bank Branch</strong
                            >
                            <p class="text-muted">
                            {{ profile.bankBranch }}
                            </p>
                            <hr />
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i
                            >IFSC Code</strong
                            >
                            <p class="text-muted">{{ profile.ifsc }}</p>
                            <hr />
                        </div>
                        </div> -->
                    </div>
                    <!-- /.card-body -->
                    </div>
                    <!-- /.card -->
                </div>
                <!-- /.tab-pane -->

                <div class="tab-pane" id="viewnominee">
                    <div class="card card-primary">
                    <div class="card-header">
                        <h3 class="card-title">Nominee & Group</h3>
                    </div>
                    <!-- /.card-header -->
                    <div class="card-body">
                        <!-- <div class="row">
                        <div class="col-md-6">
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i>
                            Nominee Name</strong
                            >
                            <p class="text-muted">
                            {{ profile.nomineeName }}
                            </p>
                            <hr />
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i>
                            Nominee Mobile Number</strong
                            >
                            <p class="text-muted">
                            {{ profile.nomineePhone }}
                            </p>
                            <hr />
                            
                        </div>
                        <div class="col-md-6">
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i
                            >Spouse</strong
                            >
                            <p class="text-muted">
                            {{ profile.nomineeSpouse }}
                            </p>
                            <hr />
                            <strong
                            ><i class="fas fa-cash-register mr-1"></i
                            >Nominee DOB</strong
                            >
                            <p class="text-muted">
                            {{ profile.nomineeDob }}
                            </p>
                            <hr />
                            
                        </div>
                        </div> -->
                    </div>
                    <!-- /.card-body -->
                    </div>
                    <!-- /.card -->
                </div>
                <!-- /.tab-pane -->
            </div>
            <!-- /.tab-content -->
          </div>
          <!-- /.nav-tabs-custom -->
           <div class="nav-tabs-custom" v-if="user.type == 'admin'">
             
              <button class="btn btn-primary" @click="newModal" data-toggle="tab">Reset Password</button>
            
           </div>
        </div>        
      </div>
      

    </section>

        <div class="modal fade" id="modal-xl">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <form @submit.prevent="resetPassword()">
                <div class="modal-header bg-aqua">
                  
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h4 class="modal-title">Reset Password</h4>
                </div>
                
                <div class="modal-body">
                  <!-- right column -->
                    
                    <div class="card card-warning">
                      <!-- /.card-header -->
                      
                      <div class="card-body">
                        
                        <div class="form-group">
                          
                            <label
                                >Old Password <span class="red">*</span></label
                            >
                            <input
                            v-model="form.old_password"
                            type="text"
                            name="old_password"
                            class="form-control"
                            required
                            :class="{
                                'is-invalid': form.errors.has('old_password'),
                            }"
                            />
                            <has-error
                            :form="form"
                            field="old_password"
                            ></has-error>
                        </div>
                        <div class="form-group">
                            <label
                                >Password <span class="red">*</span></label
                            >
                            <input
                            v-model="form.password"
                            type="text"
                            name="password"
                            class="form-control"
                            required
                            :class="{
                                'is-invalid': form.errors.has('password'),
                            }"
                            />
                            <has-error
                            :form="form"
                            field="password"
                            ></has-error>
                        </div>
                        <div class="form-group">
                            <label
                                >Confirm Password <span class="red">*</span></label
                            >
                            <input
                            v-model="form.confirm_password"
                            type="text"
                            name="confirm_password"
                            class="form-control"
                            required
                            :class="{
                                'is-invalid': form.errors.has('confirm_password'),
                            }"
                            />
                            <has-error
                            :form="form"
                            field="confirm_password"
                            ></has-error>
                        </div>
                          
                      </div>
                      
                      <!-- /.card-body -->
                    </div>
                    
                  <!--/.col (right) -->
                </div>
                
                <div class="modal-footer text-center">
                  <button type="submit" class="btn btn-success">
                    SAVE PASSWORD
                  </button>
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                  >
                    CANCEL
                  </button>
                </div>
              </form>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
        <!-- /.modal -->


  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'profile',
  computed: {
    ...mapState([
      'profile',
      'user'
    ])
  },
  data () {
    return {
      // profile: {}, // this.$store.state.profile,
      // user: {},
      logo: null,
      photo: 'https://via.placeholder.com/100/FFFF00/000000?text=Photo',
      favicon: null,
      getRecord: {},
      states: {},
      form: new Form({
        old_password: '',
        password: '',
        confirm_password: '',
        email: this.$store.state.user.email
      })
    }
  },

  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    newModal () {
      $('#modal-xl').modal({backdrop: 'static', keyboard: false})
    },
    uploadImage (event) {
      const URL = 'logo'
      let data = new FormData()
      // data.append('name', 'my-picture')
      data.append('logo', event.target.files[0])
      let config = {
        header: {
          'Content-Type': 'image/png'
        }
      }
      this.$axios.post(
        URL,
        data,
        config
      ).then(
        response => {
          this.logo = this.$store.state.imageBaseUrl + 'logo/' + response.data.logo.image_name
          console.log('image upload response > ', response)
        }
      )
    },
    updatelogo () {
      this.form.put('api/profile')
      .then(() => {
        Toast.fire({
          icon: 'success',
          title: 'User Profile Updated Successfully'
        })
      })
      .catch(() => {
        Toast.fire({
          icon: 'error',
          title: 'Please Try Again'
        })
      })
    },
    resetPassword () {
      Swal.fire({title: 'Are you sure?', text: "You won't be able to revert this!", icon: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, confirm it!'}).then((result) => {
        if (result.isConfirmed) {
          this.$axios
            .post('auth/changepassword', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
            .then(() => {
              $('#modal-xl').modal('hide')
              Toast.fire({
                icon: 'success',
                title: 'Password Updated Successfully'
              })
            })
            .catch(
              function (error) {
                Toast.fire({ icon: 'error', title: 'Please Try Again' })
                this.form.errors.errors = error.response.data.error
              }.bind(this)
            )
          Swal.fire('Success!', 'Successfully.', 'success')
        }
      })
    },
    loadData () {
      let loader = this.$loading.show()
      if (this.profile) {
        this.photo = this.$store.state.imageBaseUrl + this.profile.user_id + '/photo/' + this.profile.photo
      } else {
        this.photo = 'https://via.placeholder.com/100/ffefda/000000?text=Photo'
      }
      this.$axios
        .get('settings', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          loader.hide()
          this.getRecord = data
          if (this.getRecord.logo != null) {
            this.logo = this.$store.state.imageBaseUrl + 'logo/' + this.getRecord.logo
            if (this.getRecord.favicon != null) {
              this.favicon = this.$store.state.imageBaseUrl + 'favicon/' + this.getRecord.favicon
            }
          } else {
            alert('hello')
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      // this.$axios.get('/auth/getuser', { headers: {'Authorization': 'Bearer ' + localStorage.token} })
      //   .then(response => response.data)
      //   .then(data => {
      //     this.user = data.user
      //     this.profile = data.profile
      //   })
    },
    updateDbLedger () {
      this.$axios
        .get('user/databaseledgers', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          alert('hello')
        })
    },
    updateDatabase () {
      this.$axios
        .get('dbupdates', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          alert('hello')
        })
    }
    // downloadDatabase () {
    //   this.$axios
    //     .get('user/database', {
    //       headers: { Authorization: 'Bearer ' + localStorage.token }
    //     })
    //     .then((response) => response.data)
    //     .then((data) => {
    //       alert('hello')
    //     })
    // }
  },

  created () {
    this.loadData()
    Fire.$on('AfterCreate', () => {
      this.loadData()
    })
  }
}
</script>



// WEBPACK FOOTER //
// Profile.vue?49cf0091